import { Tag } from "../constants.mjs";
import { encode, Encoding, decode } from "../../../utils/encoder.mjs";
export default function genMapField(encoding, tag) {
  return {
    serialize(object, {
      buildTx
    }) {
      return decode(buildTx({
        tag: Tag.Mtree,
        values: Object.entries(object).map(([key, value]) => ({
          tag: Tag.MtreeValue,
          key: decode(key),
          value: decode(buildTx({
            ...value,
            tag
          }))
        }))
      }));
    },
    deserialize(buffer, {
      unpackTx
    }) {
      const {
        values
      } = unpackTx(encode(buffer, Encoding.Transaction), Tag.Mtree);
      return Object.fromEntries(values
      // TODO: remove after resolving https://github.com/aeternity/aeternity/issues/4066
      .filter(({
        key
      }) => encoding !== Encoding.ContractAddress || key.length === 32).map(({
        key,
        value
      }) => [encode(key, encoding), unpackTx(encode(value, Encoding.Transaction), tag)]));
    },
    recursiveType: true
  };
}
//# sourceMappingURL=map.mjs.map